import { render, staticRenderFns } from "./purchase-detail.vue?vue&type=template&id=5675ed58&scoped=true&"
import script from "./purchase-detail.vue?vue&type=script&lang=js&"
export * from "./purchase-detail.vue?vue&type=script&lang=js&"
import style0 from "./purchase-detail.vue?vue&type=style&index=0&id=5675ed58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675ed58",
  null
  
)

export default component.exports